<template>
  <transition name="slide">
    <div class="playback-container" :id="fullScreen">
      <div class="play-back-header">
        <span v-if="archiveOptions.archiveListLength > 1" :class="{ disabledCss: currentArchiveRunning == 1 }" class="slick-prev" @click="capturePrevVideo()"></span>
        <div class="header-text">
          <div class="title">{{ archiveOptions.telehealthName }}</div>
          <div class="timestamp">Record date: {{ archiveTime | formatArchiveDate }}</div>
        </div>
        <span
          v-if="archiveOptions.archiveListLength > 1"
          :class="{
            disabledCss: currentArchiveRunning == archiveOptions.archiveListLength
          }"
          class="slick-next"
          @click="captureNextVideo()"
        ></span>
      </div>
      <div class="video-wrap embed-responsive embed-responsive-16by9">
        <video id="video">
          <source :src="playbackUrl" type="video/mp4" />
        </video>
      </div>
      <div id="video-controls" class="controls" data-state="hidden">
        <div class="progress">
          <progress id="progress" value="0" min="0">
            <span id="progressBar"></span>
          </progress>
          <input @click="skipAhead($event)" class="seek" id="seek" value="0" min="0" type="range" step="1" />
        </div>
        <button @click="closePanel()" class="close-panel" type="button">
          <i class="fa fa-times" aria-hidden="true"></i>
          <span>Close</span>
        </button>
        <button @click="togglePlay()" class="ml-3" id="playpause" type="button" data-state="play">
          <i class="fa" :class="playPausedClass" aria-hidden="true"></i>
        </button>
        <button id="micClass" type="button" class="mr-3" @click="toggleSound()" data-state="micClass">
          <span v-if="micClass == 'fa-volume-up'" class="speaker-icon"></span>
          <span v-else class="speaker-off"></span>
        </button>
        <span class="time-controls"
          ><span id="time-elapse">{{ timeElapsed }}</span> / <span v-if="duration" id="duration">{{ duration }}</span></span
        >
        <span v-if="fullScreen == 'fullScreen'" @click="screenSwitch()" id="full-screen-icon"
          ><span><img alt="Fullscreen" src="/static/img/Fullscreen.png"/></span
        ></span>
        <span v-if="fullScreen != 'fullScreen'" @click="screenSwitch()" id="full-screen-icon"
          ><span><img alt="Fullscreen-white" src="/static/img/telehealth/Fullscreen-white.png"/></span
        ></span>
      </div>
      <downloadVideoModal :showModal="showModal" :archiveId="archiveOptions.archiveId" @change-modal-state="updateModalState()"></downloadVideoModal>
    </div>
  </transition>
</template>

<script>
import downloadVideoModal from "./download-video-modal";
import toastr from "toastr";
import * as commonHelper from "@/components/services/common-helper";

export default {
  name: "PlaybackThCall",
  data() {
    return {
      videoEle: null,
      videoControls: null,
      playPausedClass: "fa-play",
      progressBar: null,
      progress: null,
      duration: "00:00",
      timeElapsed: "00:00",
      showModal: false,
      seek: null,
      micClass: "fa-volume-up",
      currentArchiveRunning: this.archiveOptions.archiveIndex,
      playbackUrl: this.archiveOptions.archiveUrl,
      isVideoLoading: false,
      archiveTime: this.archiveOptions.archiveListLength > 1 ? this.archiveOptions.archiveList[this.archiveOptions.archiveIndex - 1].startTime : this.archiveOptions.recordDate
    };
  },
  computed: {},
  components: { downloadVideoModal },
  props: {
    archiveOptions: {
      type: Object
    },
    videoObj: {
      type: Object
    },
    fullScreen: {
      type: String
    }
  },
  methods: {
    closePanel() {
      this.$root.$emit("playBackVideoEnded");
    },
    errorHandler(err) {
      if (err.name == "OT_USER_MEDIA_ACCESS_DENIED" && this.screenShareValue !== "") {
        toastr.error("Screen sharing has been declined");
        this.screenShareValue = "video";
        this.changeModeValue = false;
      } else if (err.name == "OT_USER_MEDIA_ACCESS_DENIED") {
        toastr.warning("Please grant access to camera and microphone in order to start the call");
      } else {
        toastr.error(err.message);
      }
    },
    togglePlay() {
      if (this.videoEle.paused || this.videoEle.ended) {
        this.videoEle.play();
        this.changeBtnClass("fa-pause");
        const tDuration = Math.round(this.videoEle.duration);
        this.duration = commonHelper.formatTime(Math.round(tDuration));
      } else {
        this.videoEle.pause();
        this.changeBtnClass("fa-play");
      }
    },
    toggleSound() {
      this.videoEle.muted = !this.videoEle.muted;
      if (this.videoEle.muted) {
        this.micClass = "fa-volume-off";
      } else {
        this.micClass = "fa-volume-up";
      }
    },
    changeBtnClass(cssClass) {
      this.playPausedClass = cssClass;
    },
    initialiseTheVideo() {
      this.videoEle = document.getElementById("video");
      this.videoControls = document.getElementById("video-controls");
      this.progressBar = document.getElementById("progressBar");
      this.progress = document.getElementById("progress");
      this.progress.classList.add("progress-crome");
      this.seek = document.getElementById("seek");
      this.setAsPerTheObjValues();
    },
    setAsPerTheObjValues() {
      if (this.videoObj == null) {
        return;
      }
      this.timeElapsed = this.videoObj.timeElapsed;
      this.duration = this.videoObj.duration;
      this.videoEle.currentTime = this.videoObj.currentTime;
    },
    screenSwitch() {
      const videoObj = {
        type: this.fullScreen == "fullScreen" ? "thPanel" : "fullScreen",
        timeElapsed: this.timeElapsed,
        duration: this.duration,
        currentTime: this.videoEle.currentTime,
        videoEleObj: this.videoEle
      };
      this.$emit("switchScreen", videoObj);
    },
    downloadVideo() {
      toastr.warning("This feature is not enabled.");
      return;
    },
    updateModalState(value) {
      this.showModal = value;
    },
    skipAhead(event) {
      const skipTo = event.target.dataset.seek ? event.target.dataset.seek : event.target.value;
      this.videoEle.currentTime = skipTo;
      self.progressBar.value = skipTo;
      self.seek.value = skipTo;
    },
    captureNextVideo() {
      if (this.currentArchiveRunning == this.archiveOptions.archiveListLength) {
        return;
      }
      this.isVideoLoading = true;
      this.currentArchiveRunning = this.currentArchiveRunning + 1;
      this.$root.$emit("switchVideo", this.archiveOptions.archiveList[this.currentArchiveRunning - 1]);
      this.archiveTime = this.archiveOptions.archiveList[this.currentArchiveRunning - 1].startTime;
      this.playPausedClass = "fa-play";
      this.getArchiveUrl(this.$route.params.studyId, this.archiveOptions.archiveList[this.currentArchiveRunning - 1].archiveId);
    },
    capturePrevVideo() {
      if (this.currentArchiveRunning == 1) {
        return;
      }
      this.isVideoLoading = true;
      this.currentArchiveRunning = this.currentArchiveRunning - 1;
      this.$root.$emit("switchVideo", this.archiveOptions.archiveList[this.currentArchiveRunning - 1]);
      this.archiveTime = this.archiveOptions.archiveList[this.currentArchiveRunning - 1].startTime;
      this.playPausedClass = "fa-play";
      this.getArchiveUrl(this.$route.params.studyId, this.archiveOptions.archiveList[this.currentArchiveRunning - 1].archiveId);
    },
    getArchiveUrl(studyId, archiveId) {
      this.$api.getArchiveUrl(studyId, archiveId).then(response => {
        this.playbackUrl = response.body;
        this.videoEle.load();
        this.isVideoLoading = false;
      });
    }
  },
  mounted() {
    const self = this;
    this.initialiseTheVideo();
    commonHelper.videoRecordingcalcluation(this.videoEle);
    setTimeout(() => {
      this.videoEle.addEventListener("timeupdate", function() {
        self.progress.value = self.videoEle.currentTime;
        self.seek.setAttribute("max", self.videoEle.duration);
        self.seek.value = Math.floor(self.videoEle.currentTime);
        self.progressBar.style.width = Math.floor((self.videoEle.currentTime / self.videoEle.duration) * 100) + "%";
        self.progress.setAttribute("max", self.videoEle.duration);
        self.timeElapsed = commonHelper.formatTime(Math.round(self.videoEle.currentTime));
        if (self.progress.value == self.videoEle.duration) {
          self.changeBtnClass("fa-play");
          self.videoEle.pause();
        }
      });
    }, 0);
  }
};
</script>

<style lang="scss" scoped>
.playback-container {
  width: 100%;
  height: 100%;
  background: #000;
  .video-wrap {
    height: 75%;
  }
  .play-back-header {
    width: 100%;
    height: 68px;
    background: #fff;
    text-align: center;
    padding: 12px;
    .header-text {
      display: inline-block;
    }
    .title {
      font-size: 14px;
    }
    .description {
      font-size: 12px;
    }
  }
  #video-controls {
    position: absolute;
    bottom: 25px;
    width: 100%;
    text-align: center;
    button {
      display: inline-block;
      background: transparent;
      border: none;
      margin: 0 auto;
      color: #fff;
      cursor: pointer;
    }
    button:focus {
      outline: none;
    }
    .progress {
      position: relative;
      display: flex;
      overflow: hidden;
      font-size: 0.75rem;
      border-radius: none;
      background: transparent;
      margin-top: 13px;
      progress {
        width: 0%;
        margin: 0 auto;
        height: 0px;
      }
    }
    .close-panel {
      width: 67px;
      border: 1px solid #fff;
      background: #fff;
      border-radius: 2px;
      font-size: 12px;
      i {
        color: #000;
      }
      span {
        padding-left: 4px;
        color: #4c8ce4;
      }
    }
  }
  // Defining color for the playback slider, ends
  .inline-controls {
    display: inline-block;
    width: 120px;
    color: #fff;
    .download {
      display: inline-block;
      cursor: pointer;
    }
    #full-screen-icon {
      cursor: pointer;
      display: inline-block;
      span {
        display: inline-block;
        width: 17px;
        height: 17px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  // remove this css when enabled the down load button
  #full-screen-icon {
    cursor: pointer;
    display: inline-block;
    margin-left: 11px;
    span {
      display: inline-block;
      width: 17px;
      height: 17px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  // till here
  .time-controls {
    color: #fff;
  }
}
#fullScreen {
  &.playback-container {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6); /* Black background with opacity */
    .video-wrap {
      height: 65%;
      top: 23px;
    }
    .play-back-header {
      width: 100%;
      height: 70px;
      background: #fff;
      text-align: center;
      padding: 12px;
      .title {
        font-size: 14px;
      }
      .description {
        font-size: 12px;
      }
    }
    #video-controls {
      position: absolute;
      height: 90px;
      background: #353b4a;
      opacity: 0.7;
      bottom: 0px;
      width: 100%;
      text-align: center;
      button {
        display: inline-block;
        background: transparent;
        border: none;
        margin: 0 auto;
        color: #fff;
        cursor: pointer;
        margin-right: 10px;
        &.close-panel {
          background: #fff;
        }
      }
      button:focus {
        outline: none;
      }
      .progress {
        position: relative;
        display: flex;
        overflow: hidden;
        font-size: 0.75rem;
        border-radius: none;
        background: transparent;
        margin-top: 13px;
        progress {
          width: 0%;
          margin: 0 auto;
          height: 0px;
        }
      }
    }
    .close-panel {
      width: 61px;
      border: 1px solid #fff;
      background: #fff;
      border-radius: 2px;
      i {
        color: #000;
      }
      span {
        padding-left: 4px;
        color: #4c8ce4;
      }
    }
    .inline-controls {
      display: inline-block;
      width: 132px;
      color: #fff;
      .download {
        display: inline-block;
        cursor: pointer;
      }
      #full-screen-icon {
        cursor: pointer;
        display: inline-block;
        margin-left: 10px;
        span {
          display: inline-block;
          width: 20px;
          height: 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .time-controls {
      color: #fff;
      margin-left: 8px;
      margin-right: 5px; // it should be 22px once download btn enabled
    }
  }
}
.slick-prev.slick-disabled:before,
.slick-next.slick-disabled:before {
  opacity: 0.25;
}
.slick-prev:before,
.slick-next:before {
  font: normal normal normal 40px/1 FontAwesome;
  line-height: 1;
  color: #1e8fe1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.slick-prev {
  position: absolute;
  left: 10px;
  cursor: pointer;
}
[dir="rtl"] .slick-prev {
  right: -25px;
  left: auto;
}
.slick-prev:before {
  content: "\f104";
  font-size: 36px;
}
.slick-next {
  position: absolute;
  right: 10px;
  cursor: pointer;
}
.slick-next:before {
  content: "\f105";
}
// common
.disabledCss {
  opacity: 0.4;
}
.loading-class {
  margin-top: 15%;
  margin-left: 50%;
}
.speaker-icon {
  background-image: url(/static/img/telehealth/speaker.png);
  width: 17px;
  height: 20px;
  background-size: contain;
  display: inline-block;
  background-repeat: no-repeat;
  position: relative;
  top: 7px;
}
.speaker-off {
  background-image: url(/static/img/telehealth/mute-1.png);
  width: 17px;
  height: 20px;
  background-size: contain;
  display: inline-block;
  background-repeat: no-repeat;
  position: relative;
  top: 7px;
}
</style>
<style scoped lang="scss" src="@/assets/range-slider.scss"></style>
<style scoped lang="scss" src="@/assets/dot-streaching-loader.scss"></style>
